// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Decimal } from 'decimal.js';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import TemplateContract from './TemplateContract';

export const getHoldingsToCoverAmount: (
  holdings: TemplateContract<Holding>[],
  requiredAmount: Decimal,
) => TemplateContract<Holding>[] = (holdings, requiredAmount) => {
  const sortedHoldings = [...holdings].sort((a, b) =>
    new Decimal(a.payload.amount).comparedTo(new Decimal(b.payload.amount)),
  );

  const { result, accumulated } = sortedHoldings.reduce(
    (acc, holding) => {
      if (acc.accumulated.greaterThanOrEqualTo(requiredAmount)) {
        return acc; // already satisfied
      }

      const amount = new Decimal(holding.payload.amount);
      return {
        result: [...acc.result, holding],
        accumulated: acc.accumulated.plus(amount),
      };
    },
    {
      result: [] as TemplateContract<Holding>[],
      accumulated: new Decimal(0),
    },
  );

  return accumulated.greaterThanOrEqualTo(requiredAmount) ? result : [];
};
